<template>
  <div class="basket-product-popup shop-popup">
    <div class="content">
      <img
        @click="$parent.popupAvailableProduct = false"
        src="@/assets/images/shop-close.svg"
        class="close"
      />
      <h5 class="desktop">
        Вы подписаны на уведомление о наличии товара на складе
      </h5>
      <h5 class="mobile">
        Вы подписаны на уведомление о наличии товара на складе
      </h5>
      <div class="product">
        <div
          class="image"
          :style="{
            background: product.images[0].image.background_color,
          }"
        >
          <img :src="product.images[0].image.image_object_middle" />
        </div>
        <div class="info">
          <span class="name">{{ product.headline_preview }}</span>
          <span class="quantity">
            {{ product.feature_product_quantity }}
            <span v-if="product.release_form">
              {{
                getDeclination(
                  product.feature_product_quantity,
                  product.release_form
                )
              }}
            </span>
          </span>
        </div>
      </div>
      <div class="buttons">
        <button @click="$parent.popupAvailableProduct = false">Закрыть</button>
      </div>
    </div>
  </div>
</template>
<script>
import productMixin from "@/mixins/productMixin";

export default {
  mixins: [productMixin],
  props: {
    product: Object,
  },
};
</script>
